import AnalyticsService from '@emcd-shared/analytics-service'
import { WILDCARDS_DOMAIN } from '../common/const'

export const getMainDomain = () => {
  const hostname =
    typeof window !== 'undefined' ? window.location.hostname : null
  if (!hostname) return null

  if (WILDCARDS_DOMAIN.global) {
    WILDCARDS_DOMAIN.lastIndex = 0
  }
  
  const match = WILDCARDS_DOMAIN.exec(hostname)
  if (!match) {
    AnalyticsService.error(`Unsupported domain ${hostname}`)
    return null
  }
  
  const mainDomain = match[2]
  
  // Для localhost возвращаем как есть
  if (mainDomain === 'localhost') {
    return mainDomain
  }
  
  // Для mytstnv.site возвращаем домен с учетом следующего уровня
  if (mainDomain === 'mytstnv.site') {
    const parts = hostname.split('.')
    if (parts.length >= 3) {
      // Если есть поддомены, берем предпоследний и последний части
      // partner.dev-b2b.mytstnv.site -> dev-b2b.mytstnv.site
      const subdomain = parts[parts.length - 3] // dev-b2b
      const domain = parts[parts.length - 2]    // mytstnv
      const tld = parts[parts.length - 1]       // site
      return `${subdomain}.${domain}.${tld}`
    }
    // Если нет поддоменов, возвращаем как есть
    return mainDomain
  }
  
  // Для остальных доменов добавляем точку
  return `.${mainDomain}`
}


